/* eslint-disable import/prefer-default-export */
const CANNABIS_DURATIONS = {
  development: {
    VBaS9qnn55gj3FvHi3eVfI8M9kg1: 15,
  },
  qa: {
    oubAKAE2MLOJqdoB7BCqGmHCkLL2: 15,
  },
  prod: {
    FhF6FytE0pMXty46uTRM39RJTNR2: 15,
  },
};

export const APPOINTMENT_DURATIONS = {
  cannabis: CANNABIS_DURATIONS,
  mendo: CANNABIS_DURATIONS,
  aurora: CANNABIS_DURATIONS,
  hybridpharm: CANNABIS_DURATIONS,
  vivo: CANNABIS_DURATIONS,
  default: 10,
};

export const CANNABIS_SKILLS = {
  DEV: 'wm4lOS9WA87QmVLwip0r', // 'Cannabis'
  QA: 'MjTfmhTwXdon6PTlhQGw', // 'Cannabis'
  PROD: 'S4Udxb9kT0TuIXXhKNWo', // 'Cannabis'
};

export const CANNABIS_EMPLOYEE_IDS = {
  DR_T_SAEED: 'TVX0pxqNqyeuz9uY4bbKkkgQWo72',
  // TVX0pxqNqyeuz9uY4bbKkkgQWo72
  DR_BHATTI: 'RYeT8PyW2iR2JuDmgAHpgdPpxe92',
  DR_SAEED: 'WHChBhGn7OdSCg8v4BsJAGtOEew2',
  DR_GILLEN_STEPH: 'xXAMsblnWaMQ6xslElKV3dJqZTF3',
  DR_GILLEN_RAMI: 'VLWuZEKLouWTQxN5WoBfeVgldWa2',
};
export const CANNABIS_EMPLOYEE_IDS_QA = {
  DR_T_SAEED: 'oubAKAE2MLOJqdoB7BCqGmHCkLL2',
  DR_BHATTI: 'WwEP1O6B7HV0HIjq5EXuWDaOB7e2',
  DR_SAEED: 'I0gcPzHuDNW6wO9Ee2tGSsfXLjN2',
};
